module.exports = __webpack_public_path__ + "static/media/paris-aerial.0a36ef3e.jpg";